module.exports = __webpack_public_path__ + "img/detalhe.d123ecb7.png";